var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuedetailStackMemoryIcon = function SvgNewcsDashboardCrashanalysisIssuedetailStackMemoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_crashanalysis_issuedetail_stack_memory_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M578 905h14v14h-14z",
    "data-name": "\\u77E9\\u5F62 397"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuedetail_stack_memory_icon_svg__a)",
    transform: "translate(-578 -905)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M587.333 909.667h-4.667v4.667h4.667Zm-1.556 3.111h-1.556v-1.556h1.556Zm6.223-1.556v-1.556h-1.556v-1.556a1.56 1.56 0 0 0-1.556-1.556h-1.556V905h-1.556v1.556h-1.556V905h-1.556v1.556h-1.556a1.56 1.56 0 0 0-1.556 1.556v1.556H578v1.556h1.556v1.556H578v1.556h1.556v1.556a1.56 1.56 0 0 0 1.556 1.556h1.556V919h1.556v-1.556h1.556V919h1.556v-1.556h1.556a1.56 1.56 0 0 0 1.556-1.556v-1.556H592v-1.556h-1.556v-1.556H592Zm-3.111 4.667h-7.778v-7.778h7.778z"
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuedetailStackMemoryIcon;